import LoadingPage from '../LoadingPage';

function LoadingScreen() {
  return <LoadingPage />;
}

export default LoadingScreen;
